import styled from 'styled-components';
import bundleBackground from '../../../../images/Oval.svg';

const ContainerListStyled = styled.div`
  width: 100%;
  padding: 15px 15px 20px 15px;
  margin-bottom: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: 99;
  background: linear-gradient(0deg, #cdbed5 0%, #e6e5ed 100%);
  mix-blend-mode: normal;
  opacity: 0.95;
  box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  div {
    position: relative;
    z-index: 2;
  }

  p {
    position: relative;
    z-index: 2;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #553e65;
    width: 100%;
  }

  figure {
    z-index: 1;
    svg {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
`;

const DetailStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 17px;
  picture {
    min-width: 35px;
    height: 34px;
    margin-right: 13px;
    img {
      width: 100%;
    }
  }
  hgroup {
    color: #381451;
    text-transform: uppercase;
    h3 {
      font-size: 14px;
      line-height: 16px;
    }
    h4 {
      font-size: 26px;
      line-height: 26px;
      font-weight: 500;
    }
  }
`;

const ContentFooterStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  p {
    margin-left: 15px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    align-items: center;
    color: #381451;
  }
`;

const FinalTextStyled = styled.div`
  text-align: center;
  margin: auto;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #553e65;
  p {
    margin-bottom: 25px;
    font-size: 16px;
    line-height: 20px;
  }
`;

const WrapperListStyled = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const ListTitleStyled = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #553e65;
`;

const ContentStyled = styled.div`
  width: 100%;
  margin-bottom: 20px;
  margin-top: 14px;
`;

const WarningMessageStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: #e92070;
  box-shadow: 0px 2px 44px rgba(0, 0, 0, 0.113253);
  border-radius: 10px;
  padding: 5px 10px;
  img {
    width: 30px;
    margin-right: 10px;
  }
  p {
    color: #ffffff;
    font-size: 16px;
    line-height: 20px;
  }
`;

const ContainerStyled = styled.div`
  position: relative;
`;

const ContainerGreyStyled = styled.div`
  background: #e6e2e8;
  overflow-y: auto;
  height: 100%;
`;

const HeaderStyled = styled.div`
  background: #2d1540;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px 25px 0;
  height: auto;
`;

const HeaderOvalStyled = styled.div`
  height: 25px;
  width: 100%;
  background-image: url(${bundleBackground});
  background-size: cover;
  background-position-y: bottom;
  background-position-x: center;
  top: 0;
  position: relative;
  z-index: 1;
`;

const PriceContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;
const PriceTextStyled = styled.h3`
  font-weight: 700;
  font-size: 26px;
  line-height: 32px;
  color: #381451;
`;
const PriceWarningStyled = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #381451;
  text-transform: uppercase;
`;

export {
  HeaderStyled,
  HeaderOvalStyled,
  ContainerStyled,
  ContainerListStyled,
  WrapperListStyled,
  ListTitleStyled,
  WarningMessageStyled,
  ContentStyled,
  ContentFooterStyled,
  DetailStyled,
  FinalTextStyled,
  ContainerGreyStyled,
  PriceContainerStyled,
  PriceTextStyled,
  PriceWarningStyled,
};
